import { ItemBaseModel } from '../item-base.model';
import { InputItemBaseModel, InputValueType, SingleItemModel } from '../single';
import { GroupItemModel } from './group-item.model';

// eslint-disable-next-line @typescript-eslint/typedef
const GroupItemTypeNames = ['step', 'form', 'list'] as const;

export type GroupItemType = typeof GroupItemTypeNames[number];

export interface GroupValueType {
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  [k: string]: InputValueType | GroupValueType;
}

export interface GroupItemBaseModel extends Omit<InputItemBaseModel, 'type'> {
  type: GroupItemType;
  name: string;
  title?: string;
  description?: string;
  items: (SingleItemModel | GroupItemBaseModel)[];
}

export const isGroupItem = (item: ItemBaseModel): item is GroupItemModel => {
  return GroupItemTypeNames.includes(item.type as GroupItemType);
};
